import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  width: 100%;
`

export const linkListButtons = css`
  & > *:not(:last-child) {
    padding-block-end: ${spacing(1.5)};
  }
`
export const linkListButtonDefault = css`
  padding-block: 0;
`

export const accordionsContainer = css`
  & > *:not(:last-child) {
    padding-block-end: ${spacing(2)};
  }
`

export const accordionSeparationButton = css`
  border-block-start: ${spacing(0.25)} solid rgba(255, 255, 255, 0.1);
  padding-block-start: ${spacing(2)};
  margin-block-start: ${spacing(2)};
`

export const inlineSpacing = css`
  padding-inline-start: ${spacing(1.25)};
`
